enum ProjectStatus {
  Bid = 1,
  Confirmed = 2,
  OnHold = 3,
  Cancelled = 4,
  Completed = 5
}

export default ProjectStatus;
